export enum ErrorText {
    SomeThingWentWrong = 'Somthing went wrong',
    PleaseUploadTheImage = 'Please upload the image.',
    ImageRestriction = 'Please upload image as .png .jpeg and .jpg format.'
}